export default "__VITE_ASSET__C$phR0wy__"